import React from "react";
import Container from "@/components/ContentContainer/Container";
import InnerContainer from "@/components/ContentContainer/InnerContainer";
import styles from "@/pages/products/detail/relations/ProductRelations.module.scss";
import { Flex } from "antd";
import PackagingProductRelations from "@/pages/packaging/detail/relations/PackagingProductRelations";
import PackagingOrderRelations from "@/pages/packaging/detail/relations/PackagingOrderRelations";

function PackagingRelations() {
  return (
    <Flex>
      <Container
        padding={false}
        className={styles.container}
        noRoundedTop
      >
        <Flex>
          <InnerContainer
            contentClassName={styles.relations}
            borderRight
          >
            <PackagingProductRelations />
          </InnerContainer>

          <InnerContainer contentClassName={styles.relations}>
            <PackagingOrderRelations />
          </InnerContainer>
        </Flex>
      </Container>
    </Flex>
  );
}

export default PackagingRelations;
